if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}


//////////////////
// WEBPACK FOOTER
// ./assets/js/polyfill-starts-with.js
// module id = 247
// module chunks = 0